import React from 'react'
import { Container, Ellipse } from './styles'

export interface ColumnEllipseProps {
  isFilled: boolean
  children: React.ReactNode
}

export const ColumnEllipse = ({ isFilled, children }: ColumnEllipseProps): JSX.Element => {
  return (
    <Container>
      {children}
      <Ellipse className={isFilled ? 'filled' : 'outlined'} />
    </Container>
  )
}
